import * as React from 'react';
import { Dispatch, connect } from 'react-redux';
import { NotificationCard } from '@digital/react-aviva-atom';
import { bindActionCreators } from 'redux';
import { RootState } from '../../app/store';
import { setProgressStep } from '../../redux/progress-bar/progressBar';
import ConfirmationDetails from '../../components/confirmation-details/ConfirmationDetails';
import { ImportantPoints } from '../../components/important-points/ImportantPoints';
import { BookingResponseType } from '../../redux/booking/booking';

import './Confirmation.css';

interface DispatchProps {
    setProgressStep: (payload: { step: number }) => void;
}

interface InjectedProps {
    bookingResponseType?: BookingResponseType;
}

type Props = DispatchProps & InjectedProps;

export class Confirmation extends React.PureComponent<Props> {

    componentDidMount() {
        this.props.setProgressStep({ step: 4 });
        let appEventData = 'AppEventData';
        window[appEventData].push({
            event: 'stepLoaded',
            page: {
                'pageName': 'ie:secure:my-aviva:driving-school:confirmation',
                'channel': 'secure'
              }
        });
    }

    renderNotificationCardText(responseType?: BookingResponseType) {
        switch (responseType) {
            case BookingResponseType.DetailsError:
                return 'Your payment has been successful but we cannot confirm your booking.';
            default:
                return 'Your payment has been successful but we cannot confirm your booking. \
                        Please review the following errors below.';
        }
    }

    render() {
        const { bookingResponseType } = this.props;
        const bookingSuccessful = bookingResponseType === BookingResponseType.Success;
        const aviva = import.meta.env.VITE_DS_AVIVA_URL;
        return (
            <div>
                {bookingSuccessful &&
                    <h3 className="text__center confirmation-header">
                        Thank you. Your booking has been successful
                    </h3>
                }
                {!bookingSuccessful &&
                    <NotificationCard
                        className="error-warning"
                        type="warning"
                    >
                        {this.renderNotificationCardText(bookingResponseType)}
                    </NotificationCard>
                }
                <ConfirmationDetails />
                <ImportantPoints />
                <div className="aviva-button-background">
                    <div className="aviva-button">
                        <a className="btn-link" href={aviva} tabIndex={-1}>
                            <button
                                className="a-button a-button--primary a-button--full-width"
                            >
                                Return to Aviva.ie
                            </button>
                        </a>
                    </div>
                </div >
            </div>
        );
    }
}

export function mapStateToProps(state: RootState) {
    const { booking } = state;
    return {
        bookingResponseType: booking.bookingResponseType
    };
}

const mapDispatchToProps = (dispatch: Dispatch<RootState>) => {
    return bindActionCreators(
        {
            setProgressStep
        },
        dispatch
    );
};

export default connect<InjectedProps, DispatchProps>(mapStateToProps, mapDispatchToProps)(Confirmation);